import "core-js/modules/es6.array.map";
import "core-js/modules/es6.function.bind";
import _regeneratorRuntime from "/codebuild/output/src2888051775/src/www-public/node_modules/@babel/runtime/regenerator";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
import _classCallCheck from "/codebuild/output/src2888051775/src/www-public/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src2888051775/src/www-public/node_modules/@babel/runtime/helpers/esm/createClass";
import { __rest, __awaiter } from './../../../../../../ext/tslib/tslib.es6.js';
import { CanvasContext } from '../../../../../types/dist/rrweb-types.js';
import WorkerFactory from '../../../../../../_virtual/image-bitmap-data-url-worker.js';
import { isBlocked } from '../../../utils.js';
import initCanvas2DMutationObserver from './2d.js';
import initCanvasContextObserver from './canvas.js';
import initCanvasWebGLMutationObserver from './webgl.js';

var CanvasManager = /*#__PURE__*/function () {
  _createClass(CanvasManager, [{
    key: "reset",
    value: function reset() {
      this.pendingCanvasMutations.clear();
      this.resetObservers && this.resetObservers();
    }
  }, {
    key: "freeze",
    value: function freeze() {
      this.frozen = true;
    }
  }, {
    key: "unfreeze",
    value: function unfreeze() {
      this.frozen = false;
    }
  }, {
    key: "lock",
    value: function lock() {
      this.locked = true;
    }
  }, {
    key: "unlock",
    value: function unlock() {
      this.locked = false;
    }
  }]);

  function CanvasManager(options) {
    var _this = this;

    _classCallCheck(this, CanvasManager);

    this.pendingCanvasMutations = new Map();
    this.rafStamps = {
      latestId: 0,
      invokeId: null
    };
    this.frozen = false;
    this.locked = false;

    this.processMutation = function (target, mutation) {
      var newFrame = _this.rafStamps.invokeId && _this.rafStamps.latestId !== _this.rafStamps.invokeId;
      if (newFrame || !_this.rafStamps.invokeId) _this.rafStamps.invokeId = _this.rafStamps.latestId;

      if (!_this.pendingCanvasMutations.has(target)) {
        _this.pendingCanvasMutations.set(target, []);
      }

      _this.pendingCanvasMutations.get(target).push(mutation);
    };

    var _options$sampling = options.sampling,
        sampling = _options$sampling === void 0 ? 'all' : _options$sampling,
        win = options.win,
        blockClass = options.blockClass,
        blockSelector = options.blockSelector,
        recordCanvas = options.recordCanvas,
        dataURLOptions = options.dataURLOptions;
    this.mutationCb = options.mutationCb;
    this.mirror = options.mirror;
    if (recordCanvas && sampling === 'all') this.initCanvasMutationObserver(win, blockClass, blockSelector);
    if (recordCanvas && typeof sampling === 'number') this.initCanvasFPSObserver(sampling, win, blockClass, blockSelector, {
      dataURLOptions: dataURLOptions
    });
  }

  _createClass(CanvasManager, [{
    key: "initCanvasFPSObserver",
    value: function initCanvasFPSObserver(fps, win, blockClass, blockSelector, options) {
      var _this2 = this;

      var canvasContextReset = initCanvasContextObserver(win, blockClass, blockSelector, true);
      var snapshotInProgressMap = new Map();
      var worker = new WorkerFactory();

      worker.onmessage = function (e) {
        var id = e.data.id;
        snapshotInProgressMap.set(id, false);
        if (!('base64' in e.data)) return;
        var _e$data = e.data,
            base64 = _e$data.base64,
            type = _e$data.type,
            width = _e$data.width,
            height = _e$data.height;

        _this2.mutationCb({
          id: id,
          type: CanvasContext['2D'],
          commands: [{
            property: 'clearRect',
            args: [0, 0, width, height]
          }, {
            property: 'drawImage',
            args: [{
              rr_type: 'ImageBitmap',
              args: [{
                rr_type: 'Blob',
                data: [{
                  rr_type: 'ArrayBuffer',
                  base64: base64
                }],
                type: type
              }]
            }, 0, 0]
          }]
        });
      };

      var timeBetweenSnapshots = 1000 / fps;
      var lastSnapshotTime = 0;
      var rafId;

      var getCanvas = function getCanvas() {
        var matchedCanvas = [];
        win.document.querySelectorAll('canvas').forEach(function (canvas) {
          if (!isBlocked(canvas, blockClass, blockSelector, true)) {
            matchedCanvas.push(canvas);
          }
        });
        return matchedCanvas;
      };

      var takeCanvasSnapshots = function takeCanvasSnapshots(timestamp) {
        if (lastSnapshotTime && timestamp - lastSnapshotTime < timeBetweenSnapshots) {
          rafId = requestAnimationFrame(takeCanvasSnapshots);
          return;
        }

        lastSnapshotTime = timestamp;
        getCanvas().forEach(function (canvas) {
          return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            var _a, id, context, bitmap;

            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    id = this.mirror.getId(canvas);

                    if (!snapshotInProgressMap.get(id)) {
                      _context.next = 3;
                      break;
                    }

                    return _context.abrupt("return");

                  case 3:
                    snapshotInProgressMap.set(id, true);

                    if (['webgl', 'webgl2'].includes(canvas.__context)) {
                      context = canvas.getContext(canvas.__context);

                      if (((_a = context === null || context === void 0 ? void 0 : context.getContextAttributes()) === null || _a === void 0 ? void 0 : _a.preserveDrawingBuffer) === false) {
                        context.clear(context.COLOR_BUFFER_BIT);
                      }
                    }

                    _context.next = 7;
                    return createImageBitmap(canvas);

                  case 7:
                    bitmap = _context.sent;
                    worker.postMessage({
                      id: id,
                      bitmap: bitmap,
                      width: canvas.width,
                      height: canvas.height,
                      dataURLOptions: options.dataURLOptions
                    }, [bitmap]);

                  case 9:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, this);
          }));
        });
        rafId = requestAnimationFrame(takeCanvasSnapshots);
      };

      rafId = requestAnimationFrame(takeCanvasSnapshots);

      this.resetObservers = function () {
        canvasContextReset();
        cancelAnimationFrame(rafId);
      };
    }
  }, {
    key: "initCanvasMutationObserver",
    value: function initCanvasMutationObserver(win, blockClass, blockSelector) {
      this.startRAFTimestamping();
      this.startPendingCanvasMutationFlusher();
      var canvasContextReset = initCanvasContextObserver(win, blockClass, blockSelector, false);
      var canvas2DReset = initCanvas2DMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector);
      var canvasWebGL1and2Reset = initCanvasWebGLMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, this.mirror);

      this.resetObservers = function () {
        canvasContextReset();
        canvas2DReset();
        canvasWebGL1and2Reset();
      };
    }
  }, {
    key: "startPendingCanvasMutationFlusher",
    value: function startPendingCanvasMutationFlusher() {
      var _this3 = this;

      requestAnimationFrame(function () {
        return _this3.flushPendingCanvasMutations();
      });
    }
  }, {
    key: "startRAFTimestamping",
    value: function startRAFTimestamping() {
      var _this4 = this;

      var setLatestRAFTimestamp = function setLatestRAFTimestamp(timestamp) {
        _this4.rafStamps.latestId = timestamp;
        requestAnimationFrame(setLatestRAFTimestamp);
      };

      requestAnimationFrame(setLatestRAFTimestamp);
    }
  }, {
    key: "flushPendingCanvasMutations",
    value: function flushPendingCanvasMutations() {
      var _this5 = this;

      this.pendingCanvasMutations.forEach(function (values, canvas) {
        var id = _this5.mirror.getId(canvas);

        _this5.flushPendingCanvasMutationFor(canvas, id);
      });
      requestAnimationFrame(function () {
        return _this5.flushPendingCanvasMutations();
      });
    }
  }, {
    key: "flushPendingCanvasMutationFor",
    value: function flushPendingCanvasMutationFor(canvas, id) {
      if (this.frozen || this.locked) {
        return;
      }

      var valuesWithType = this.pendingCanvasMutations.get(canvas);
      if (!valuesWithType || id === -1) return;
      var values = valuesWithType.map(function (value) {
        var rest = __rest(value, ["type"]);

        return rest;
      });
      var type = valuesWithType[0].type;
      this.mutationCb({
        id: id,
        type: type,
        commands: values
      });
      this.pendingCanvasMutations["delete"](canvas);
    }
  }]);

  return CanvasManager;
}();

export { CanvasManager };